import CONSTANTS from '@/constants'

const { BLACK_FRIDAY_PRODUCT_BUNDLES, LEAP_YEAR_PROMO_PRODUCT_BUNDLES, TCS_PROMO_PRODUCT_BUNDLES } =
  CONSTANTS
const { INE_BLACK_FRIDAY_BUNDLE_ONE, INE_BLACK_FRIDAY_BUNDLE_TWO, INE_BLACK_FRIDAY_BUNDLE_THREE } =
  BLACK_FRIDAY_PRODUCT_BUNDLES
const { INE_LEAP_YEAR_BUNDLE } = LEAP_YEAR_PROMO_PRODUCT_BUNDLES
const { INE_TCS_BUNDLE } = TCS_PROMO_PRODUCT_BUNDLES

export const availableProductBundlesHydratation = productBundlesCollection => {
  const renewalMessageOpt2 =
    'Your INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term. You must cancel your subscription renewal before the scheduled renewal date to avoid auto renewal and the associated renewal fee.'
  productBundlesCollection.forEach(bundle => {
    bundle.merchant_id = bundle.slug
    switch (bundle.slug) {
      case INE_BLACK_FRIDAY_BUNDLE_ONE:
        bundle.nameToShow = 'Premium + Skill Dive + 1 INE Security Certification'
        bundle.renewalMessage =
          'Each INE subscription will automatically renew at standard stated pricing at end of each subscription term unless you cancel your renewal prior to the end of said term. You must cancel your subscription renewal before the scheduled renewal date to avoid auto renewal and the associated renewal fee.'
        break
      case INE_BLACK_FRIDAY_BUNDLE_TWO:
        bundle.nameToShow = 'Premium + 1 INE Security Certification'
        bundle.renewalMessage = renewalMessageOpt2
        break
      case INE_BLACK_FRIDAY_BUNDLE_THREE:
        bundle.nameToShow = 'Fundamentals Annual'
        bundle.renewalMessage = renewalMessageOpt2
        break
      case INE_LEAP_YEAR_BUNDLE:
        bundle.nameToShow = 'Premium + 1 INE Security Certification'
        bundle.renewalMessage = renewalMessageOpt2
        break
      case INE_TCS_BUNDLE:
        Object.assign(bundle, {
          description: null,
          price: `$${((bundle.price_cents + 50000) / 100).toFixed(2)}`,
          price_cents: bundle.price_cents + 50000,
          discounted_price: bundle.price,
          discounted_price_cents: bundle.price_cents,
          infoTitle: 'Annual Voucher Discount',
          isBestValue: true,
          link: 'https://ine.com/faqs/subscriptions/premium',
          merchant_id: bundle.slug,
          name: 'Premium',
          nameBundle: bundle.name,
          nameToShow: 'Premium + 1 INE Security Certification',
          product_type: 'bundle',
          renewalMessage: renewalMessageOpt2,
          subtitle: { text: '3500+ Training Hours', color: 'var(--strong-light-green-b5)' },
          term: 'year',
          text: 'Entire Content Library',
          tooltip:
            'Access 3500+ hours of content across 50+ learning paths <br>for all skill levels; Skill Dive not included',
          user_receives_discount: true,
        })
        break

      default:
        break
    }
  })
}
